import { craft } from "./class/craftApiClass";

const client = new craft();

export function initClient(token: string, mode: string) {
    client.token = token;
    client.endpoint = location.origin + '/api';
}

export default client;